import img1 from "src/assets/images/slider/1.avif";
import img2 from "src/assets/images/slider/2.avif";
import img3 from "src/assets/images/slider/3.avif";


export type SliderItemType = {
    name: {
        [key: string]: string
    };
    overview: {
        [key: string]: string
    };
    img: string;
};

export const sliderData: SliderItemType[] = [
    {
        "name": {
            "ar": "صيانة شاملة",
            "en": "Comprehensive Maintenance"
        },
        "overview": {
            "ar": "نوفر خدمات صيانة شاملة باستخدام تقنيات حديثة وقطع غيار أصلية لضمان أداء مركباتكم.",
            "en": "Providing comprehensive maintenance services using advanced technologies and genuine spare parts to ensure your vehicles' performance."
        },
        "img": img1
    },
    {
        "name": {
            "ar": "طاقم متخصص",
            "en": "Specialized Staff"
        },
        "overview": {
            "ar": "نعتمد على طاقم فني متخصص وأجهزة متطورة لضمان خدمات صيانة وتجديد موثوقة.",
            "en": "Relying on a specialized technical team and advanced equipment to ensure reliable maintenance and renewal services."
        },
        "img": img2
    },
    {
        "name": {
            "ar": "خدمات متكاملة",
            "en": "Integrated services"
        },
        "overview": {
            "ar": "نحرص على تقديم أفضل الخدمات المتكاملة بأعلى معايير الجودة لتلبية جميع احتياجات العملاء.",
            "en": "We strive to provide the best integrated services with the highest quality standards to meet all customer needs."
        },
        "img": img3
    }
];
